import { render, staticRenderFns } from "./AdvertiserUserList.vue?vue&type=template&id=9d2a986a&scoped=true&"
import script from "./AdvertiserUserList.vue?vue&type=script&lang=ts&"
export * from "./AdvertiserUserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2a986a",
  null
  
)

export default component.exports